import { useState } from "react";
import { PiXFill } from "react-icons/pi";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { putApi } from "../../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/toastify-message/ToastifyMessage";

function FixOrderDateModal({ onClose, onSuccess }) {
  const [trackingCode, setTrackingCode] = useState("");
  const [date, setDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!trackingCode || !date) {
      errorMessage("شماره سفارش و تاریخ را وارد کنید");
      return;
    }
    setLoading(true);
    try {
      await putApi({
        path: "admin/orders/fix-order-date",
        body: {
          trackingCode: Number(trackingCode),
          date: new Date(date).toISOString(),
        },
      });
      successMessage(`تاریخ سفارش #${trackingCode} با موفقیت اصلاح شد`);
      onSuccess?.();
      onClose();
    } catch (error) {
      errorMessage(
        error?.response?.data?.errors?.[0]?.message || "خطا در اصلاح تاریخ"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="fixed top-0 right-0 w-full h-full bg-black/40 z-[2000]"
        onClick={onClose}
      />
      <div className="fixed top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 w-[340px] md:w-[480px] bg-white dark:bg-gray-900 shadow-xl rounded-3xl p-6 z-[2010]">
        <div className="flex items-center justify-between mb-6">
          <h4 className="text-gray-800 dark:text-white font-semibold">
            اصلاح تاریخ سفارش
          </h4>
          <PiXFill
            onClick={onClose}
            size={28}
            className="text-red-400 hover:text-red-600 cursor-pointer transition-all"
          />
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              شماره سفارش
            </label>
            <input
              type="number"
              value={trackingCode}
              onChange={(e) => setTrackingCode(e.target.value)}
              placeholder="مثال: 56191"
              className="p-2.5 rounded-lg border w-full bg-gray-50 dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              تاریخ و ساعت جدید
            </label>
            <DatePicker
              format="YYYY/MM/DD HH:mm:ss"
              value={date}
              onChange={(e) => setDate(e ? new Date(e).toISOString() : null)}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              portal
              zIndex={3000}
              inputClass="p-2.5 rounded-lg border w-full bg-gray-50 dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm focus:ring-blue-500 focus:border-blue-500 text-center"
              containerStyle={{ width: "100%" }}
              plugins={[<TimePicker position="bottom" />]}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="mt-2 text-white bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-4 focus:ring-indigo-300 font-medium rounded-full px-8 py-2.5 text-center disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? "در حال اصلاح..." : "اصلاح تاریخ"}
          </button>
        </form>
      </div>
    </>
  );
}

export default FixOrderDateModal;